import Vue from 'vue'
import template from './index.pug'

// @vue/component
Vue.component('loading', {
  name: 'loading',
  template: template()
})
